import { evidenceContract } from "@clipboard-health/contract-documents-service";
import { patch } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type z } from "zod";

import { DOCUMENT_EVIDENCES_QUERY_KEY, WORKER_EVIDENCES_QUERY_KEY } from "../constants";

const bodySchema = evidenceContract.update.body;
const responseSchema = evidenceContract.update.responses[200];

export type UpdateEvidenceParams = z.input<typeof bodySchema>;

export function useUpdateEvidence() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, params }: { id: string; params: UpdateEvidenceParams }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/v2/evidences/${id}`,
        data: params,
        bodySchema,
        responseSchema,
      });
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [WORKER_EVIDENCES_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [DOCUMENT_EVIDENCES_QUERY_KEY] });
    },
    meta: { logErrorMessage: APP_V2_APP_EVENTS.UPDATE_EVIDENCE_FAILURE },
  });
}
